<template>
  <template v-if="isMobile">
    <button
      type="button"
      class="flex min-w-0 max-w-full items-center gap-1.5 transition-colors cursor-pointer xl:gap-2"
      :class="buttonClass"
      @click="open = true"
    >
      <span class="shrink-0 font-helvetica-700 text-[16px] font-bold"
        >Период:</span
      >
      <span
        :title="periodLabel"
        class="min-w-0 truncate font-helvetica-700 text-orange"
      >
        {{ periodLabel }}
      </span>
      <SvgoIconComponentFIconFilterarrow class="h-[7px] w-[11px] shrink-0 text-orange transition-transform duration-200" :class="open ? 'rotate-180' : ''"></SvgoIconComponentFIconFilterarrow>
    </button>

    <transition name="delivery-sheet-fade">
      <div
        v-if="open"
        class="fixed inset-0 z-[1500] bg-black/30 lg:hidden"
        @click.self="open = false"
      >
        <transition name="delivery-sheet-slide">
          <section
            v-if="open"
            class="absolute inset-x-0 bottom-0 max-h-[88dvh] overflow-y-auto rounded-t-[28px] bg-white px-5 pb-[calc(var(--layout-mobile-nav-height)+24px)] pt-5 shadow-[0_-12px_32px_rgb(0_0_0_/_0.12)]"
          >
            <div
              class="mx-auto flex w-full max-w-[var(--layout-mobile-max-width)] flex-col gap-4"
            >
              <div class="flex items-center justify-between gap-4">
                <p class="text-[24px] font-helvetica-700 text-gray-dark">
                  Период
                </p>
                <button
                  type="button"
                  class="relative flex h-10 w-10 items-center justify-center rounded-full border border-gray-border bg-white-gray text-gray-dark"
                  aria-label="Закрыть"
                  @click="open = false"
                >
                  <span
                    class="absolute h-[1.5px] w-4 rotate-45 rounded-full bg-current"
                  ></span>
                  <span
                    class="absolute h-[1.5px] w-4 -rotate-45 rounded-full bg-current"
                  ></span>
                </button>
              </div>

              <div
                class="rounded-[20px] border border-gray-border bg-white px-4 py-4 shadow-sm"
              >
                <div
                  class="grid grid-cols-[minmax(0,1fr)_20px_minmax(0,1fr)] items-center gap-3 px-1"
                >
                  <div class="flex flex-col gap-1">
                    <span class="text-[16px] font-helvetica-400 text-gray-dark"
                      >с</span
                    >
                    <div
                      class="relative flex h-[48px] min-w-0 w-full items-center gap-2 rounded-[12px] border border-gray-border px-3 text-[14px] font-helvetica-400 text-gray-dark transition-colors cursor-text hover:border-gray-dark focus-within:border-gray-dark focus-within:ring-0"
                    >
                      <SvgoIconComponentRIconCalendar class="h-4 w-4 text-orange"></SvgoIconComponentRIconCalendar>
                      <input
                        v-model="inputFrom"
                        type="text"
                        inputmode="numeric"
                        placeholder=""
                        class="min-w-0 flex-1 border-0 bg-transparent text-[14px] font-helvetica-400 tabular-nums text-gray-dark placeholder:text-gray-light focus:outline-none caret-gray-dark"
                        @input="
                          (e) =>
                            onManualInput(
                              'from',
                              (e.target as HTMLInputElement).value,
                            )
                        "
                      />
                      <span
                        v-if="!inputFrom"
                        class="pointer-events-none absolute inset-0 flex items-center pl-[26px] text-[14px] font-helvetica-400 text-gray-light date-placeholder"
                        >__.__.____</span
                      >
                    </div>
                  </div>
                  <div
                    class="flex items-center justify-center self-center justify-self-center"
                  >
                    <span class="text-[18px] leading-none text-extra-text-color"
                      >-</span
                    >
                  </div>
                  <div class="flex flex-col gap-1">
                    <span class="text-[16px] font-helvetica-400 text-gray-dark"
                      >по</span
                    >
                    <div
                      class="relative flex h-[48px] min-w-0 w-full items-center gap-2 rounded-[12px] border border-gray-border px-3 text-[14px] font-helvetica-400 text-gray-dark transition-colors cursor-text hover:border-gray-dark focus-within:border-gray-dark focus-within:ring-0"
                    >
                      <SvgoIconComponentRIconCalendar class="h-4 w-4 text-orange"></SvgoIconComponentRIconCalendar>
                      <input
                        v-model="inputTo"
                        type="text"
                        inputmode="numeric"
                        placeholder=""
                        class="min-w-0 flex-1 border-0 bg-transparent text-[14px] font-helvetica-400 tabular-nums text-gray-dark placeholder:text-gray-light focus:outline-none caret-gray-dark"
                        @input="
                          (e) =>
                            onManualInput(
                              'to',
                              (e.target as HTMLInputElement).value,
                            )
                        "
                      />
                      <span
                        v-if="!inputTo"
                        class="pointer-events-none absolute inset-0 flex items-center pl-[26px] text-[14px] font-helvetica-400 text-gray-light date-placeholder"
                        >__.__.____</span
                      >
                    </div>
                  </div>
                </div>

                <div class="mt-4 flex flex-col gap-3">
                  <button
                    v-for="preset in presets"
                    :key="preset.value"
                    type="button"
                    class="flex h-[54px] items-center justify-center rounded-[14px] border px-4 text-[18px] leading-[1.3] font-helvetica-400 text-gray-dark transition-colors cursor-pointer"
                    :class="[
                      isActivePreset(preset.value)
                        ? 'bg-orange border-orange text-white'
                        : 'border-gray-border bg-white hover:border-gray-dark active:bg-selected-orange active:border-selected-orange active:text-white',
                    ]"
                    @click="applyPreset(preset, () => (open = false))"
                  >
                    <span class="w-full text-center">{{ preset.label }}</span>
                  </button>
                </div>
              </div>
            </div>
          </section>
        </transition>
      </div>
    </transition>
  </template>

  <UPopover
    v-else
    v-model:open="open"
    :content="{
      side: 'bottom',
      align: 'start',
      sideOffset: 8,
      collisionPadding: { top: 120, right: 16, bottom: 16, left: 16 },
      sticky: 'always',
    }"
    :ui="{ content: 'z-[1400]' }"
  >
    <button
      type="button"
      class="flex min-w-0 max-w-full items-center gap-1.5 transition-colors cursor-pointer xl:gap-2"
      :class="buttonClass"
    >
      <span class="shrink-0 font-helvetica-700 text-[16px] font-bold"
        >Период:</span
      >
      <span
        :title="periodLabel"
        class="min-w-0 truncate font-helvetica-700 text-orange"
      >
        {{ periodLabel }}
      </span>
      <SvgoIconComponentFIconFilterarrow class="h-[7px] w-[11px] shrink-0 text-orange transition-transform duration-200" :class="open ? 'rotate-180' : ''"></SvgoIconComponentFIconFilterarrow>
    </button>

    <template #content="{ close }">
      <div
        class="max-h-[var(--reka-popper-available-height)] w-[min(360px,calc(100vw-24px))] overflow-y-auto rounded-[10px] border border-gray-border bg-white-gray px-4 py-5 shadow-sm"
      >
        <div
          class="grid grid-cols-[minmax(0,1fr)_20px_minmax(0,1fr)] items-center gap-3 px-1"
        >
          <div class="flex flex-col gap-1">
            <span class="text-[16px] font-helvetica-400 text-gray-dark">с</span>
            <div
              class="relative flex h-[40px] min-w-0 w-full items-center gap-2 rounded-[10px] border border-gray-border px-3 text-[14px] font-helvetica-400 text-gray-dark transition-colors cursor-text hover:border-gray-dark focus-within:border-gray-dark focus-within:ring-0"
            >
              <SvgoIconComponentRIconCalendar class="h-4 w-4 text-gray-dark"></SvgoIconComponentRIconCalendar>
              <input
                type="text"
                inputmode="numeric"
                placeholder=""
                v-model="inputFrom"
                class="min-w-0 flex-1 border-0 bg-transparent text-[14px] font-helvetica-400 tabular-nums text-gray-dark placeholder:text-gray-light focus:outline-none caret-gray-dark"
                @input="
                  (e) =>
                    onManualInput('from', (e.target as HTMLInputElement).value)
                "
              />
              <span
                v-if="!inputFrom"
                class="pointer-events-none absolute inset-0 flex items-center pl-[26px] text-[14px] font-helvetica-400 text-gray-light date-placeholder"
                >__.__.____</span
              >
            </div>
          </div>
          <div
            class="flex items-center justify-center self-center justify-self-center"
          >
            <span class="text-[18px] leading-none text-extra-text-color"
              >-</span
            >
          </div>
          <div class="flex flex-col gap-1">
            <span class="text-[16px] font-helvetica-400 text-gray-dark"
              >по</span
            >
            <div
              class="relative flex h-[40px] min-w-0 w-full items-center gap-2 rounded-[10px] border border-gray-border px-3 text-[14px] font-helvetica-400 text-gray-dark transition-colors cursor-text hover:border-gray-dark focus-within:border-gray-dark focus-within:ring-0"
            >
              <SvgoIconComponentRIconCalendar class="h-4 w-4 text-gray-dark"></SvgoIconComponentRIconCalendar>
              <input
                type="text"
                inputmode="numeric"
                placeholder=""
                v-model="inputTo"
                class="min-w-0 flex-1 border-0 bg-transparent text-[14px] font-helvetica-400 tabular-nums text-gray-dark placeholder:text-gray-light focus:outline-none caret-gray-dark"
                @input="
                  (e) =>
                    onManualInput('to', (e.target as HTMLInputElement).value)
                "
              />
              <span
                v-if="!inputTo"
                class="pointer-events-none absolute inset-0 flex items-center pl-[26px] text-[14px] font-helvetica-400 text-gray-light date-placeholder"
                >__.__.____</span
              >
            </div>
          </div>
        </div>

        <div class="mt-4 flex flex-col gap-2">
          <button
            v-for="preset in presets"
            :key="preset.value"
            type="button"
            class="flex h-[48px] items-center justify-center rounded-[10px] border px-4 text-[18px] leading-[1.4] font-helvetica-400 text-gray-dark transition-colors cursor-pointer"
            :class="[
              isActivePreset(preset.value)
                ? 'bg-orange border-orange text-white'
                : 'border-gray-border bg-white-gray hover:border-gray-dark active:bg-selected-orange active:border-selected-orange active:text-white',
            ]"
            @click="applyPreset(preset, close)"
          >
            <span class="w-full text-center">{{ preset.label }}</span>
          </button>
        </div>
      </div>
    </template>
  </UPopover>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted, ref, watch } from "vue";

type Range = { from: string | null; to: string | null };
type Preset = {
  label: string;
  value: string;
  from: Date;
  to: Date;
  badge?: string;
};

const props = withDefaults(
  defineProps<{
    modelValue?: Range;
    size?: "sm" | "md";
  }>(),
  {
    modelValue: () => ({ from: null, to: null }),
    size: "md",
  },
);

const emit = defineEmits<{
  (e: "update:modelValue", value: Range): void;
}>();

const open = ref(false);
const localFrom = ref<string | null>(props.modelValue.from);
const localTo = ref<string | null>(props.modelValue.to);
const activePreset = ref<string | null>(null);
const windowWidth = ref<number>(0);

const buttonClass = computed(() =>
  props.size === "sm"
    ? "text-[14px] leading-[1.4] font-helvetica-400 text-gray-dark"
    : "text-[17px] leading-[1.4] font-helvetica-400 text-gray-dark xl:text-[18px]",
);
const isMobile = computed(
  () => windowWidth.value > 0 && windowWidth.value < 1024,
);

const sanitizeInput = (val: string) => val.replace(/\D/g, "").slice(0, 8);

const formatDigitsToDisplay = (digits: string) => {
  let res = "";
  for (let i = 0; i < digits.length; i++) {
    res += digits[i];
    if (i === 1 || i === 3) res += ".";
  }
  return res;
};

const toISOFromDigits = (digits: string) => {
  if (digits.length !== 8) return null;
  const d = Number(digits.slice(0, 2));
  const m = Number(digits.slice(2, 4));
  const y = Number(digits.slice(4));
  if (m < 1 || m > 12 || d < 1 || d > 31) return null;
  const iso = `${String(y).padStart(4, "0")}-${String(m).padStart(2, "0")}-${String(d).padStart(2, "0")}`;
  const date = new Date(iso);
  if (isNaN(date.getTime())) return null;
  if (
    date.getFullYear() !== y ||
    date.getMonth() + 1 !== m ||
    date.getDate() !== d
  )
    return null;
  return iso;
};

const toDisplay = (iso: string | null) => {
  if (!iso) return "";
  const date = new Date(iso);
  if (isNaN(date.getTime())) return "";
  const dd = String(date.getDate()).padStart(2, "0");
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const yy = date.getFullYear();
  return `${dd}.${mm}.${yy}`;
};

const inputFrom = ref<string>(
  props.modelValue.from ? toDisplay(props.modelValue.from) : "",
);
const inputTo = ref<string>(
  props.modelValue.to ? toDisplay(props.modelValue.to) : "",
);

const formatDateLabel = (value: string | null) => {
  if (!value) return "__.__.____";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "__.__.____";
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();
  return `${dd}.${mm}.${yy}`;
};

const periodLabel = computed(() => {
  const fromLabel = formatDateLabel(localFrom.value);
  const toLabel = formatDateLabel(localTo.value);
  return `${fromLabel} – ${toLabel}`;
});

const startOfDay = (date: Date) => {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
};
const endOfDay = (date: Date) => {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d;
};

const today = startOfDay(new Date());
const presets = computed<Preset[]>(() => {
  const now = new Date();
  const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
  const currentPeriodEnd = endOfDay(now);
  const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const lastMonthEnd = endOfDay(new Date(now.getFullYear(), now.getMonth(), 0));
  const threeMonthsAgo = new Date(now.getFullYear(), now.getMonth() - 2, 1);
  const yearStart = new Date(now.getFullYear(), 0, 1);

  return [
    { label: "Сегодня", value: "today", from: today, to: endOfDay(today) },
    {
      label: "Вчера",
      value: "yesterday",
      from: startOfDay(new Date(today.getTime() - 86400000)),
      to: endOfDay(new Date(today.getTime() - 86400000)),
    },
    {
      label: "Текущий месяц",
      value: "current-month",
      from: currentMonthStart,
      to: currentPeriodEnd,
    },
    {
      label: "Прошлый месяц",
      value: "last-month",
      from: lastMonthStart,
      to: lastMonthEnd,
    },
    {
      label: "Последние 3 месяца",
      value: "last-3-months",
      from: startOfDay(threeMonthsAgo),
      to: currentPeriodEnd,
    },
    {
      label: "Год",
      value: "year",
      from: startOfDay(yearStart),
      to: currentPeriodEnd,
    },
  ];
});

const emitRange = () => {
  emit("update:modelValue", { from: localFrom.value, to: localTo.value });
};

const onManualInput = (field: "from" | "to", val: string) => {
  const digits = sanitizeInput(val);
  const display = formatDigitsToDisplay(digits);
  if (field === "from") {
    inputFrom.value = display;
    if (!digits.length) {
      localFrom.value = null;
      emitRange();
      return;
    }
    const iso = toISOFromDigits(digits);
    if (iso) {
      localFrom.value = iso;
      emitRange();
    }
  } else {
    inputTo.value = display;
    if (!digits.length) {
      localTo.value = null;
      emitRange();
      return;
    }
    const iso = toISOFromDigits(digits);
    if (iso) {
      localTo.value = iso;
      emitRange();
    }
  }
};

const isActivePreset = (value: string) => activePreset.value === value;

const applyPreset = (preset: Preset, close: () => void) => {
  activePreset.value = preset.value;
  localFrom.value = preset.from.toISOString().slice(0, 10);
  localTo.value = preset.to.toISOString().slice(0, 10);
  inputFrom.value = toDisplay(localFrom.value);
  inputTo.value = toDisplay(localTo.value);
  emitRange();
  close();
};

watch(
  () => props.modelValue,
  (next) => {
    localFrom.value = next?.from ?? null;
    localTo.value = next?.to ?? null;
    inputFrom.value = next?.from ? toDisplay(next.from) : "";
    inputTo.value = next?.to ? toDisplay(next.to) : "";
  },
  { deep: true },
);

const updateWindowWidth = () => {
  if (typeof window === "undefined") return;
  windowWidth.value = window.innerWidth;
};

onMounted(() => {
  updateWindowWidth();
  window.addEventListener("resize", updateWindowWidth);
});

onBeforeUnmount(() => {
  if (typeof window === "undefined") return;
  window.removeEventListener("resize", updateWindowWidth);
});
</script>

<style scoped>
.date-placeholder {
  letter-spacing: 0.6px;
}

.delivery-sheet-fade-enter-active,
.delivery-sheet-fade-leave-active,
.delivery-sheet-slide-enter-active,
.delivery-sheet-slide-leave-active {
  transition: all 0.2s ease;
}

.delivery-sheet-fade-enter-from,
.delivery-sheet-fade-leave-to {
  opacity: 0;
}

.delivery-sheet-slide-enter-from,
.delivery-sheet-slide-leave-to {
  transform: translateY(18px);
  opacity: 0;
}
</style>
